module.exports = __webpack_public_path__ + "img/icon-search.30841247.svg";